import { ERRORS } from './csvFormatErrorsMessages';

export default {
  STATUS: [
    { KEY: 0, VALUE: 'CRIADO' },
    { KEY: 1, VALUE: 'EM PROCESSAMENTO' },
    { KEY: 2, VALUE: 'COMPLETADA' },
    { KEY: 3, VALUE: 'ERRO' },
    { KEY: 4, VALUE: 'EXPIRADO' },
    { KEY: 5, VALUE: 'CANCELADO' },
  ],
};

const FILE_ERROR = [
  {
    code: 'InvalidHeader',
    errorMessage: 'O cabeçalho do arquivo .csv é inválido.',
    helpMessage:
      'Os seguintes campos são obrigatórios: nome, cpf, valor.',
  },
  {
    code: 'MissingQuotes',
    errorMessage: 'A linha possui campo não terminado.',
    helpMessage: '',
  },
  {
    code: 'UndetectableDelimiter',
    errorMessage:
      'Não foi possível detectar automaticamente o caracter delimitante.',
    helpMessage: 'Utilize sempre o delimitante ","(vírgula).',
  },
  {
    code: 'TooManyFields',
    errorMessage: 'Muitos campos.',
    helpMessage:
      'Os seguintes campos são obrigatórios: nome, cpf, valor.',
  },
  {
    code: 'TooFewFields',
    errorMessage: 'Poucos campos.',
    helpMessage:
      'Os seguintes campos são obrigatórios: nome, cpf, valor.',
  },
  {
    code: 'InvalidCPFFormat',
    errorMessage: 'O CPF informado é inválido.',
    helpMessage:
      'Verifique o formato (deve ser 000.000.000-00 ou 00000000000) e se o mesmo possui um valor válido.',
  },
];

const INVALID_HEADER = 'InvalidHeader';

// Header format of the .csv file
const HEADER_FORMAT = [
  { header: 'nome', key: 'name', required: true },
  { header: 'CPF', key: 'document', required: true },
  { header: 'valor', key: 'value', required: true },
];

const CSV_MODEL_URL =
  'https://drive.google.com/file/d/1YG-aFFOEKo6XMuClzdrkGUGoMK4bAYC7/view?usp=sharing';

const MAX_FILE_SIZE = 100 * Math.pow(2, 10); // 100 KB ~ 1500 Rows

export { CSV_MODEL_URL, ERRORS, FILE_ERROR, HEADER_FORMAT, INVALID_HEADER, MAX_FILE_SIZE };

